/*
on react-native-web,
the react-native's `Modal` component has a z-index of 9999 while
tamagui's `Alert` component has a z-index of ~6000.
neither of these z-indices are controllable via api, but we're going
to assume that all alerts must appear above everything else, including
Modals, so we're going to use some global css to force it as such
*/
body > div:has(#id-for-yeeting-the-root-z-index) {
  z-index: 10000;
}
